import React from 'react'
import { reverse } from 'named-urls'
import { Redirect, useParams } from 'react-router-dom'
import { Box, Container, Typography } from '@material-ui/core'

import NewPasswordForm from './components/Form'

import routes from 'Routes'
import useStyles from './styles'
import constants from 'constants/index'

const NewPassword = ({ match }) => {
  const { PLATFORM_SLUG_ID } = constants.settings

  const classes = useStyles()
  const { slug } = useParams()

  if (!match.params.reset_password_token) {
    return (
      <Redirect
        to={{
          pathname: reverse(routes.root, {
            slug: slug || PLATFORM_SLUG_ID,
          }),
          state: {
            error:
              'Você não pode acessar essa página para redefinir sua senha. Certifique-se de estar usando a URL correta.',
          },
        }}
      />
    )
  }

  const defaultValues = {
    password: '',
    passwordConfirm: '',
    resetPasswordToken: match.params.reset_password_token,
  }

  return (
    <Box className={classes.root}>
      <Container maxWidth="sm" fullWidth>
        <Typography variant="h4" color="textPrimary" className={classes.title}>
          Cadastre sua nova senha!
        </Typography>
        <Box className={classes.card}>
          <Box mt={3}>
            <NewPasswordForm defaultValues={defaultValues} />
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default NewPassword
